import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-unit-or-sublot-allocation-methods',
  templateUrl: './unit-or-sublot-allocation-methods.component.html',
  styleUrls: ['./unit-or-sublot-allocation-methods.component.css']
})
export class UnitOrSublotAllocationMethodsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.UnitOrSublotAllocationMethods.columns;
    this.data = this.report.UnitOrSublotAllocationMethods.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.UnitOrSublotAllocationMethods.data;
    const gridInstance = this.gridContext.getInstance('UnitOrSublotAllocationMethods');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/unit-or-sublot-allocation-methods/unit-or-sublot-allocation-methods.component.ts